import React from 'react';
import styles from '../../styles/archiveui.module.css';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

interface ConfirmBulkActionProps {
  modal: boolean;
  toggle: () => void;
  onConfirm: () => void | Promise<void>;
  headerText: string;
  bodyText: string;
  confirmButtonText?: string;
  confirmButtonColor?: string;
  warningText?: string;
}

const ConfirmBulkAction = ({
  modal,
  toggle,
  onConfirm,
  headerText,
  bodyText,
  confirmButtonText = 'Confirm',
  confirmButtonColor = 'primary',
  warningText,
}: ConfirmBulkActionProps) => {
  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>{headerText}</ModalHeader>
      <ModalBody>
        {bodyText}
        {warningText && (
          <div style={{ marginTop: '1em', padding: '0.75em', backgroundColor: '#fff3cd', borderRadius: '0.25rem', border: '1px solid #ffc107' }}>
            <strong>Warning:</strong> {warningText}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button className={styles.scrbBtnBlue} onClick={toggle}>
          Cancel
        </Button>{' '}
        <Button color={confirmButtonColor} onClick={onConfirm}>
          {confirmButtonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmBulkAction;
